var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8Dots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 23,
    viewBox: "0 0 10 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0.01 0.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.01 -0.099)",
    fill: "#376796"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.01 5.901)",
    fill: "#376796"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.01 12.901)",
    fill: "#376796"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.01 18.901)",
    fill: "#376796"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(6.274)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.284 -0.099)",
    fill: "#376796"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.284 5.901)",
    fill: "#376796"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    "data-name": "Ellipse 5",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.284 12.901)",
    fill: "#376796"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6-2",
    "data-name": "Ellipse 6",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.284 18.901)",
    fill: "#376796"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8Dots);
export default __webpack_public_path__ + "static/media/8dots.9cc3bc030cd985773916ed6f47c8aec6.svg";
export { ForwardRef as ReactComponent };